gsap.registerPlugin(ScrollTrigger, ScrollSmoother);


const body = document.querySelector('body');
const pageWrapper = body.querySelector('.page-wrapper');

//header 
const header = document.querySelector('header');
const headerWrapMobile = header.querySelector('.header-wrap__mobile');
const mobileMenuHandler = header.querySelector('.mobile-menu__handler');


mobileMenuHandler.addEventListener('click', () => {
  headerWrapMobile.classList.toggle('active');
  mobileMenuHandler.classList.toggle('active');
});

//modal sites
const modalsitesHandler = document.querySelectorAll('.modalsites');
const modalsitesWrapper = document.querySelector('.modalsites-wrapper');
const closeModale = document.querySelectorAll('.close-modale');

modalsitesHandler.forEach(handler => {
  handler.addEventListener('click', () => {
    modalsitesWrapper.classList.add('active');
    body.style.overflow = 'hidden';
  });
});

closeModale.forEach(close => {
  close.addEventListener('click', () => {
    modalsitesWrapper.classList.remove('active');
    body.style.overflow = '';
  });
});

// header scroll behavior
let lastScrollTop = 0;
const scrollThreshold = 20;

window.addEventListener('scroll', () => {
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  if (Math.abs(scrollTop - lastScrollTop) < scrollThreshold) {
    return;
  }

  if (scrollTop > lastScrollTop && scrollTop > scrollThreshold) {
    header.classList.add('header-hidden');
  } else {
    header.classList.remove('header-hidden');
  }

  lastScrollTop = scrollTop;
});


document.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(ScrollTrigger);

  function generateClipPath(progress) {
    // Se progress è 0, ritorna un clip-path vuoto
    if (progress <= 0) {
      return 'polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)';
    }

    const stripes = 60;
    const stripeHeight = 100 / stripes;
    let points = [];

    for (let i = 0; i < stripes; i++) {
      const y1 = i * stripeHeight;

      // Calcola il progresso per questa striscia specifica
      // Le strisce in basso (i alto) partono prima - effetto cascata dal basso verso l'alto
      const stripeDelay = (stripes - 1 - i) / stripes; // 1 per la prima, 0 per l'ultima
      const stripeProgress = Math.max(0, Math.min(1, (progress - stripeDelay * 0.5) / 0.5));

      const y2 = y1 + (stripeHeight * stripeProgress);

      if (y2 > y1) {
        points.push(`0% ${y1.toFixed(2)}%`);
        points.push(`100% ${y1.toFixed(2)}%`);
        points.push(`100% ${y2.toFixed(2)}%`);
        points.push(`0% ${y2.toFixed(2)}%`);
      }
    }

    return `polygon(${points.join(', ')})`;
  }

  // Imposta lo stato iniziale dei testi
  gsap.set(".text-1", { opacity: 1, zIndex: 2 });
  gsap.set(".text-2", { opacity: 0, zIndex: 1 });
  gsap.set(".text-2 .text-anim", { opacity: 0, y: 20 });

  // Crea una timeline automatica con animazione fluida
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: ".banner",
      start: "top top",
      end: "+=100%",
      pin: true,
      scrub: 1,
      markers: false
    }
  });

  // Oggetto per tracciare il progresso dell'animazione
  const progressObj = { value: 0 };


  tl.to({}, { duration: 1 });

  // Fase 2: Animazione veneto-effect con clip-path
  tl.to(progressObj, {
    value: 1,
    duration: 3,
    ease: "power1.inOut",
    onUpdate: () => {
      document.querySelector(".image-1").style.clipPath = generateClipPath(progressObj.value);
    }
  });

  // Fase 3: Hold finale (1 secondo)
  tl.to({}, { duration: 1 });

  // Animazione parallela delle immagini (zoom leggero)
  tl.to(".image-2", { scale: 1.1, ease: "none", duration: 5 }, 0);
  tl.to(".image-1", { scale: 1.1, ease: "none", duration: 5 }, 0);

  // Animazione del testo con stagger: il primo testo scompare e il secondo appare
  tl.to(".text-1", {
    opacity: 0,
    zIndex: 1,
    ease: "power1.inOut",
    duration: 1.2
  }, 2); // Inizia a 2 secondi (durante l'animazione veneto-effect)

  tl.to(".text-1 .text-anim", {
    opacity: 0,
    y: -20,
    ease: "power1.inOut",
    duration: 1.2,
    stagger: 0.15
  }, 2);

  tl.to(".text-2", {
    opacity: 1,
    zIndex: 2,
    ease: "power1.inOut",
    duration: 1.2
  }, 2.5);

  tl.to(".text-2 .text-anim", {
    opacity: 1,
    y: 0,
    ease: "power1.out",
    duration: 1.2,
    stagger: 0.15
  }, 2.5); // Inizia a 2.5 secondi (subito dopo che text-2 diventa visibile)

  // Animazione parallax

  const sectionParallax = document.querySelector('.section-parallax');
  const sectionParallaxRow = sectionParallax.querySelectorAll('.parallax-row');
  ScrollTrigger.matchMedia({
    "(min-width: 1024px)": function () {
      sectionParallaxRow.forEach(row => {
        const items = row.querySelectorAll('.parallax-item');
        items.forEach((item, i) => {
          const index = i + 1;
          gsap.fromTo(item, { top: 30 * index }, {
            top: -80 * index + .64,
            scrollTrigger: {
              trigger: row,
              start: 'top bottom',
              end: 'bottom top',
              scrub: true,
              markers: false,
            },
          });
        });
      });
    },
    "(max-width: 1023px)": function () {
      sectionParallaxRow.forEach(row => {
        const items = row.querySelectorAll('.parallax-item');
        items.forEach((item, i) => {
          const index = i + 2;
          gsap.fromTo(item, { top: 50 * index }, {
            top: -20 * index + .52,
            scrollTrigger: {
              trigger: row,
              start: 'top bottom',
              end: 'bottom top',
              scrub: true,
              markers: false,
            },
          });
        });
      });
    },
  });
});

// banner timeline loop animation
const bannerTimeline = document.querySelector('.banner-timeline');
if (bannerTimeline) {
  const bannerTimelineItems = bannerTimeline.querySelectorAll('.loop-animation li');

  if (bannerTimelineItems.length) {
    gsap.set(bannerTimelineItems, { opacity: 0, y: 50 });

    const loopTl = gsap.timeline({ repeat: -1 });

    bannerTimelineItems.forEach((item) => {
      loopTl
        .set(item, { opacity: 0, y: 50, position: 'relative' })
        .to(item, {
          opacity: 1,
          y: 0,
          duration: 0.5,
          ease: 'power2.out',
        })
        .to(item, {
          opacity: 0,
          duration: 0.5,
          ease: 'power2.in',
          onComplete: () => {
            item.style.position = 'absolute';
          },
        }, '+=2');
    });
  }
}